"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getLanguageTitles;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _phrase = require("@insided/deprecated-libs/translationsUtils/phrase");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getLanguageTitle(_x) {
  return _getLanguageTitle.apply(this, arguments);
}

function _getLanguageTitle() {
  _getLanguageTitle = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(language) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Promise(function (resolve) {
              var languageTitlePhrase = "multi_language.language_title.".concat(language.locale.toLowerCase());
              (0, _phrase.fetchPhrase)('Forum', languageTitlePhrase, function (languageTitlePhraseTranslation) {
                var languageTitle = !languageTitlePhraseTranslation || languageTitlePhraseTranslation === languageTitlePhrase ? language.name : languageTitlePhraseTranslation;
                resolve("".concat(languageTitle).concat(language.isDefault ? ' (Default)' : ''));
              }, undefined, true);
            });

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getLanguageTitle.apply(this, arguments);
}

function getLanguageTitles(_x2) {
  return _getLanguageTitles.apply(this, arguments);
}

function _getLanguageTitles() {
  _getLanguageTitles = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(languages) {
    var languagePromises, languagePromisesResults, result;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            languagePromises = languages.map( /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(language) {
                return _regenerator.default.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", new Promise(function (resolve) {
                          getLanguageTitle(language).then(function (languageTitle) {
                            resolve((0, _defineProperty2.default)({}, language.locale, languageTitle));
                          });
                        }));

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x3) {
                return _ref.apply(this, arguments);
              };
            }());
            _context3.next = 3;
            return Promise.all(languagePromises);

          case 3:
            languagePromisesResults = _context3.sent;
            result = languagePromisesResults.reduce(function (titles, languagePromiseResult) {
              return _objectSpread(_objectSpread({}, titles), languagePromiseResult);
            }, {});
            return _context3.abrupt("return", result);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getLanguageTitles.apply(this, arguments);
}